import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();

export default async function getFormData(component, formId, callback) {
	console.log('getFormData formId', formId);
	firebaseRef
		.ref(
			'/kavtek_forms/' + PROJECT_CODE.projectCode + '/' + component + '/'
		)
		.orderByKey()
		.equalTo(formId)
		.once('value', (snapshot) => {
			console.log('getFormData snapshot', snapshot.val());

			callback(snapshot.val());
		});
}
